import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { ClassNameProp, OnClickProp } from '@swf/core/types/Props';

import ListItem from '../../../../../ListItem/ListItem';

import { TXTCLI_Province } from './SignupState.messages.json';

interface Props extends Partial<ClassNameProp>, OnClickProp {
  selected?: boolean;
  value?: string;
  text?: string;
}

const SignupState: React.FunctionComponent<Props> = ({ value, text, className, ...props }) => (
  <ListItem
    primary={text ? text : <Translation {...TXTCLI_Province} />}
    classes={{ selected: className }}
    {...props}
    textOnly
  />
);
export default SignupState;
